import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 14,
  path: '/examine',
  component: Home,
  redirect: '/examine/examineAll/city',
  name: 'examine',
  isHead: true,
  meta: {
    title: '绩效考核',
    img: require('@/assets/img/cxgj.png')
  },
  children: [
    {
      path: 'examineAll',
      component: () => import('@/views/examine/index'),
      name: 'examineAll',
      meta: { title: '绩效考核', close: false },
      children: [
        {
          path: 'city',
          component: () => import('@/views/examine/city/index'),
          name: 'city',
          meta: { title: '市直', next: '/examine/examineAll/county', close: false}
        }, {
          path: 'county',
          component: () => import('@/views/examine/county/index'),
          name: 'county',
          meta: { title: '区县', next: '/examine/examineAll/cityTable1', close: false}
        },
        {
          path: 'numberOfTasksCity',
          component: () => import('@/views/examine/numberOfTasksCity/index'),
          name: 'numberOfTasksCity',
          meta: { title: '市直', close: false}
        }, {
          path: 'numberOfTasksCounty',
          component: () => import('@/views/examine/numberOfTasksCounty/index'),
          name: 'numberOfTasksCounty',
          meta: { title: '区县', close: false}
        },
        {
          path: 'cityTable1',
          component: () => import('@/views/examine/cityTable1/index'),
          name: 'cityTable1',
          meta: { title: '报表(一)', close: false }
        },
        {
          path: 'cityTable2',
          component: () => import('@/views/examine/cityTable2/index'),
          name: 'cityTable2',
          meta: { title: '报表(二)', close: false }
        },
        {
          path: 'cityTable3',
          component: () => import('@/views/examine/cityTable3/index'),
          name: 'cityTable3',
          meta: { title: '报表(三)', close: false }
        },
        {
          path: 'cityTable4',
          component: () => import('@/views/examine/cityTable4/index'),
          name: 'cityTable4',
          meta: { title: '报表(四)', close: false }
        },
        {
          path: 'citySummaryFilling',
          component: () => import('@/views/examine/citySummaryFilling/index'),
          name: 'citySummaryFilling',
          meta: { title: '每月小结填报', close: false }
        },
        {
          path: 'scoringCity',
          component: () => import('@/views/examine/scoringCity/index'),
          name: 'scoringCity',
          meta: { title: '市直', close: false}
        }, {
          path: 'scoringCounty',
          component: () => import('@/views/examine/scoringCounty/index'),
          name: 'scoringCounty',
          meta: { title: '区县', close: false}
        },
        {
          path: 'countyTable1',
          component: () => import('@/views/examine/countyTable1/index'),
          name: 'countyTable1',
          meta: { title: '报表(一)', close: false }
        },
        {
          path: 'countyTable2',
          component: () => import('@/views/examine/countyTable2/index'),
          name: 'countyTable2',
          meta: { title: '报表(二)', close: false }
        },
        {
          path: 'countyTable3',
          component: () => import('@/views/examine/countyTable3/index'),
          name: 'countyTable3',
          meta: { title: '报表(三)', close: false }
        },
        {
          path: 'countyTable4',
          component: () => import('@/views/examine/countyTable4/index'),
          name: 'countyTable4',
          meta: { title: '报表(四)', close: false }
        },
        {
          path: 'countySummaryFilling',
          component: () => import('@/views/examine/countySummaryFilling/index'),
          name: 'countySummaryFilling',
          meta: { title: '每月小结填报', close: false }
        },
        {
          path: 'manualCity',
          component: () => import('@/views/examine/manualCity/index'),
          name: 'manualCity',
          meta: { title: '市直(手工数据)', close: false}
        }, {
          path: 'manualCounty',
          component: () => import('@/views/examine/manualCounty/index'),
          name: 'manualCounty',
          meta: { title: '区县(手工数据)', close: false}
        },{
          path: 'monthlySummaryCollect',
          component: () => import('@/views/examine/monthlySummaryCollect/index'),
          name: 'monthlySummaryCollect',
          meta: { title: '每月小结汇总', close: false}
        },
      ]
    },
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/examine.js